import {ReactNode} from 'react';
import {useThemeSelector} from '@ui/themes/theme-selector-context';

interface Props {
  id: string;
  title: ReactNode;
  titleSuffix?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}

export function AccountSettingsPanel({
  id,
  title,
  titleSuffix,
  children,
  actions,
}: Props) {
  const {selectedTheme} = useThemeSelector();
  const isDarkMode = selectedTheme?.is_dark ?? true;

  const containerBg = isDarkMode ? '#0b1120' : '#ffffff';
  const containerBorder = isDarkMode ? '#1e293b' : '#e2e8f0';
  const textColor = isDarkMode ? '#f8fafc' : '#0f172a';

  return (
    <section
      id={id}
      style={{
        backgroundColor: containerBg,
        border: `1px solid ${containerBorder}`,
        borderRadius: '20px',
        padding: '24px 28px',
        marginBottom: '28px',
        boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.25)' : '0 2px 10px rgba(0,0,0,0.03)',
        transition: 'background-color 0.2s, border-color 0.2s',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '14px',
          borderBottom: `1px solid ${containerBorder}`,
          paddingBottom: '16px',
          marginBottom: '24px',
        }}
      >
        <div style={{ fontSize: '18px', fontWeight: 800, color: textColor, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ width: '4px', height: '18px', borderRadius: '4px', background: 'linear-gradient(to bottom, #f59e0b, #e11d48)' }} />
          {title}
        </div>
        {titleSuffix && <div>{titleSuffix}</div>}
      </div>

      <div>{children}</div>

      {actions && (
        <div
          style={{
            marginTop: '28px',
            display: 'flex',
            justifyContent: 'flex-end',
            borderTop: `1px solid ${containerBorder}`,
            paddingTop: '16px',
          }}
        >
          {actions}
        </div>
      )}
    </section>
  );
}
